import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function Copy({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
            className='icon'
            {...rest} >
            <path
                d="M9.19999 5.60001H3.2C2.5382 5.60001 2 6.13821 2 6.8V12.8C2 13.4618 2.5382 14 3.2 14H9.19999C9.86179 14 10.4 13.4618 10.4 12.8V6.8C10.4 6.13821 9.86179 5.60001 9.19999 5.60001Z"
                fill={color}/>
            <path
                d="M12.8001 2.00003H6.8001C6.48184 2.00003 6.17661 2.12646 5.95157 2.3515C5.72653 2.57654 5.6001 2.88177 5.6001 3.20003V4.40003H10.4001C10.7183 4.40003 11.0236 4.52645 11.2486 4.7515C11.4737 4.97654 11.6001 5.28176 11.6001 5.60002V10.4H12.8001C13.1183 10.4 13.4236 10.2736 13.6486 10.0485C13.8737 9.8235 14.0001 9.51828 14.0001 9.20002V3.20003C14.0001 2.88177 13.8737 2.57654 13.6486 2.3515C13.4236 2.12646 13.1183 2.00003 12.8001 2.00003Z"
                fill={color}/>
        </svg>
    );
}

export default Copy;
